import { render, staticRenderFns } from "./ReceivingList.vue?vue&type=template&id=25317208&"
import script from "./ReceivingList.vue?vue&type=script&lang=js&"
export * from "./ReceivingList.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports